<!-- "in project" and one pill per project (colour dot and name; the chosen one in the main colour), shown only with
     several projects to choose from. Emits pick with the project id. Used by the inline "New tag" and "New format"
     fields (NewTagField.vue, NewFormatField.vue). -->
<script setup lang="ts">
import { useI18n } from '../../composables/useI18n'
import { safeColor } from '../../utils/color'
import type { Project } from '../../data/types'

defineProps<{ projects: Project[]; pid: string }>()
const emit = defineEmits<{ pick: [pid: string] }>()
const { t } = useI18n()
</script>

<template>
  <span v-if="projects.length > 1" class="inline-flex items-center gap-1 text-[10px] text-gray-400 mr-1">{{ t('in project') }}
    <button v-for="p in projects" :key="p.id" type="button"
      :class="['inline-flex items-center gap-1 px-2 py-1 rounded-full font-bold', pid === p.id ? 'bg-brand text-white' : 'bg-darkinput text-gray-300']"
      @click="emit('pick', p.id)"><span class="w-1.5 h-1.5 rounded-full inline-block flex-shrink-0" :style="{ background: safeColor(p.color) }"></span>{{ p.name }}</button>
  </span>
</template>
